export default __webpack_public_path__ + "static/2-a3f7fa739fe450dab37555778bbfd818.png";